import { addArrayToDiscard, replaceHand } from '../stores/cards'
0
const transparentCard = {
  name: 'transparent',
  value: 0,
  displayClass: 'transparent',
  handIndex: null,
}

const rows = 3
const cols = 3
let hand
let player

function checkForSeries(currentPlayer, seriesHand, index) {
  let row
  let col
  let hasSeries = false
  player = currentPlayer
  hand = [...seriesHand]
  row = rowMatches(index)
  if (row > -1) {
    hasSeries = true
    deleteRow(row)
  }
  col = colMatches(index)
  if (col > -1) {
    hasSeries = true
    deleteCol(col)
  }
  
  return hasSeries
}

function deleteRow(row) {
  const hnd = [...hand]
  if (rows === 0) {
    console.log('Delete last row.')
  }
  switch (row) {
    case 0:
      addArrayToDiscard([hnd[0], hnd[1], hnd[2]])
      hnd[0] = copyObject(hnd[3])
      hnd[1] = copyObject(hnd[4])
      hnd[2] = copyObject(hnd[5])
      hnd[3] = copyObject(hnd[6])
      hnd[4] = copyObject(hnd[7])
      hnd[5] = copyObject(hnd[8])
      hnd[6] = copyObject(transparentCard)
      hnd[7] = copyObject(transparentCard)
      hnd[8] = copyObject(transparentCard)
      break
    case 1:
      addArrayToDiscard([hnd[3], hnd[4], hnd[5]])
      hnd[3] = copyObject(hnd[6])
      hnd[4] = copyObject(hnd[7])
      hnd[5] = copyObject(hnd[8])
      hnd[6] = copyObject(transparentCard)
      hnd[7] = copyObject(transparentCard)
      hnd[8] = copyObject(transparentCard)
      break
    case 2:
      addArrayToDiscard([hnd[6], hnd[7], hnd[8]])
      hnd[6] = copyObject(transparentCard)
      hnd[7] = copyObject(transparentCard)
      hnd[8] = copyObject(transparentCard)
      break
  }
  for (let i = 0; i < 9; i++) {
    if (hnd[i].displayClass !== 'transparent') {
      hnd[i].handIndex = i
    }
  }
  replaceHand(player, hnd)
}

function deleteCol(col) {
  const hnd = [...hand]
  if (cols === 0) {
    console.log('Delete last col.')
  }
  switch (col) {
    case 0:
      addArrayToDiscard([hnd[0], hnd[3], hnd[6]])
      hnd[0] = copyObject(hnd[1])
      hnd[3] = copyObject(hnd[4])
      hnd[6] = copyObject(hnd[7])
      hnd[1] = copyObject(hnd[2])
      hnd[4] = copyObject(hnd[5])
      hnd[7] = copyObject(hnd[8])
      hnd[2] = copyObject(transparentCard)
      hnd[5] = copyObject(transparentCard)
      hnd[8] = copyObject(transparentCard)
      break
    case 1:
      addArrayToDiscard([hnd[1], hnd[4], hnd[7]])
      hnd[1] = copyObject(hnd[2])
      hnd[4] = copyObject(hnd[5])
      hnd[7] = copyObject(hnd[8])
      hnd[2] = copyObject(transparentCard)
      hnd[5] = copyObject(transparentCard)
      hnd[8] = copyObject(transparentCard)
      break
    case 2:
      addArrayToDiscard([hnd[2], hnd[5], hnd[8]])
      hnd[2] = copyObject(transparentCard)
      hnd[5] = copyObject(transparentCard)
      hnd[8] = copyObject(transparentCard)
      break
  }
  for (let i = 0; i < 9; i++) {
    if (hnd[i].displayClass !== 'transparent') {
      hnd[i].handIndex = i
    }
  }
  replaceHand(player, hnd)
}

function rowMatches(index) {
  if (index >= 0 && index <= 2) {
    if (
      hand[0].displayClass !== 'visible' ||
      hand[1].displayClass !== 'visible' ||
      hand[2].displayClass !== 'visible'
    ) {
      return -1
    }
    if (hand[0].value === hand[1].value && hand[0].value === hand[2].value) {
      return 0
    }
  }
  if (index >= 3 && index <= 5) {
    if (
      hand[3].displayClass !== 'visible' ||
      hand[4].displayClass !== 'visible' ||
      hand[5].displayClass !== 'visible'
    ) {
      return -1
    }
    if (hand[3].value === hand[4].value && hand[3].value === hand[5].value) {
      return 1
    }
  }
  if (index >= 6 && index <= 8) {
    if (
      hand[6].displayClass !== 'visible' ||
      hand[7].displayClass !== 'visible' ||
      hand[8].displayClass !== 'visible'
    ) {
      return -1
    }
    if (hand[6].value === hand[7].value && hand[6].value === hand[8].value) {
      return 2
    }
  }
}

function colMatches(index) {
  if (index === 0 || index === 3 || index === 6) {
    if (
      hand[0].displayClass !== 'visible' ||
      hand[3].displayClass !== 'visible' ||
      hand[6].displayClass !== 'visible'
    ) {
      return -1
    }
    if (hand[0].value === hand[3].value && hand[0].value === hand[6].value) {
      return 0
    }
  }
  if (index === 1 || index === 4 || index === 7) {
    if (
      hand[1].displayClass !== 'visible' ||
      hand[4].displayClass !== 'visible' ||
      hand[7].displayClass !== 'visible'
    ) {
      return -1
    }
    if (hand[1].value === hand[4].value && hand[1].value === hand[7].value) {
      return 1
    }
  }
  if (index === 2 || index === 5 || index === 8) {
    if (
      hand[2].displayClass !== 'visible' ||
      hand[5].displayClass !== 'visible' ||
      hand[8].displayClass !== 'visible'
    ) {
      return -1
    }
    if (hand[2].value === hand[5].value && hand[2].value === hand[8].value) {
      return 2
    }
  }
}

function copyObject(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const stringObject = JSON.stringify(obj)
    const newObject = JSON.parse(stringObject)
    return newObject
  }
  return null
}

function getHandValue(hand) {
  return hand.reduce((accumulator, card) => {
    return accumulator + card.value
  }, 0)
}

export { checkForSeries, getHandValue, copyObject }
